import styled from 'styled-components';

export default styled.div`
  width: 100%;
  min-height: 36px;
  display: grid;
  grid-template-columns: 23% 17% 9% 8% 9% 10% 7% 17%;
  grid-template-rows: 1fr;
  grid-template-areas: 'Experience CvCoverage Status ImprovementRate AverageCv AverageVisit AverageCvr RoundTimeline';
`;

export const Experience = styled.div`
  grid-area: Experience;
`;

export const CvCoverage = styled.div`
  grid-area: CvCoverage;
`;

export const Status = styled.div`
  grid-area: Status;
`;

export const ImprovementRate = styled.div`
  grid-area: ImprovementRate;
`;

export const AverageCv = styled.div`
  grid-area: AverageCv;
`;

export const AverageVisit = styled.div`
  grid-area: AverageVisit;
`;

export const AverageCvr = styled.div`
  grid-area: AverageCvr;
`;

export const RoundTimeline = styled.div`
  grid-area: RoundTimeline;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/ExperienceTableGridLayout.tsx